// extracted by mini-css-extract-plugin
export var externalLink = "_d3-0";
export var internalLinkLabel = "_d3-1";